/*
* string.js
*
* These are common methods used in C# which are handy to use in JavaScript
* They provide a common interface for working with strings in JavaScript
*/

/* 
* String.Foramt
*
* Provides functionality to access localized strings.  To use a string the code would look like:
*
*/
String.Format = function () {
    var stringValue = arguments[0];     // The first argument is the string to format

    // loop through all of the additional arguments and replace {x} with the appropriate value
    for (var i = 0; i < arguments.length - 1; i++) {
        var reg = new RegExp("\\{" + i + "\\}", "gm");
        stringValue = stringValue.replace(reg, arguments[i + 1]);
    }

    return stringValue;
};

String.prototype.endsWith = function (suffix) {
    return this.length >= suffix.length && this.substr(this.length - suffix.length) == suffix;
};

String.prototype.endsWithIgnoreCase = function (suffix) {
    return this.length >= suffix.length && this.toUpperCase().substr(this.length - suffix.length) == suffix.toUpperCase();
};

String.prototype.equalsIgnoreCase = function (otherString) {
    return this.toUpperCase().trim() === otherString.toUpperCase().trim();
};

String.prototype.startsWith = function (prefix) {
    return this.length >= prefix.length && this.substr(0, prefix.length) == prefix;
};

String.prototype.trimNewline = function () {
    return this.replace(/(\r|\n|\r\n)/gm, "");
};

String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
};

String.prototype.isEmpty = function () {
    return this.trim() == "";
};

String.prototype.contains = function (it) {
    return this.indexOf(it) != -1;
};

String.prototype.escapeSingleQuote = function () {
    return this.replace("\"", "\"\"");
}; 

//Replaces all instances of searchString with replacers in this. if caseSensitive is true then
//  "test" != "Test" (default value of caseSensitive is true)
String.prototype.ReplaceAll = function (searchString, replacer, caseSensitive) {
    if (caseSensitive === null || caseSensitive === undefined)
        caseSensitive = true;
    return this.replace(new RegExp(searchString, "g" + (caseSensitive ? "" : "i")), replacer);
};

String.prototype.NotHTMLDoc = function () {
    var str = this.toString();
    return !(str.toUpperCase().indexOf("<!DOCTYPE") != -1 || (str.toUpperCase().indexOf("<HTML") != -1 && str.toUpperCase().indexOf("<HEAD") != -1 && str.toUpperCase().indexOf("<BODY") != -1));
};

String.prototype.hashCode = function () {
    var hash = 0, i, chr, len;
    if (this.length === 0) return hash;
    for (i = 0, len = this.length; i < len; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};

